import React from 'react'
import {OwnershipStructure} from '@modifi/enums'
import {lightGray} from '@modifi/colors'

import SingleEntityIcon from '../../../../assets/graphics/single-entity-icon'
import GroupOwnershipIcon from '../../../../assets/graphics/group-ownership-icon'

export const companyOwnershipStructureOptions = [
  {
    value: OwnershipStructure.SINGLE_ENTITY,
    label: `company-ownership-structure.value.${OwnershipStructure.SINGLE_ENTITY}`,
    description: `company-ownership-structure.description.${OwnershipStructure.SINGLE_ENTITY}`,
    icon: <SingleEntityIcon width="100%" height={70} />,
  },
  {
    value: OwnershipStructure.GROUP,
    label: `company-ownership-structure.value.${OwnershipStructure.GROUP}`,
    description: `company-ownership-structure.description.${OwnershipStructure.GROUP}`,
    icon: <GroupOwnershipIcon width="100%" height={75} color={lightGray} />,
  },
]
